import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';
import FundraisingCosts from '../../../../../02_molecules/FundraisingCosts';
import TotalCost from '../../../../../02_molecules/TotalCost';

import styles from './index.module.scss';

const StripeForm = ({ paymentButton, title, showFundraisingCosts = false }) => {
  const { values } = useFormState();

  return (
    <div className={styles['stripe-form']}>
      <div className={styles['stripe-form__container']}>
        <div className={styles['stripe-form__container-left']}>
          <div className={styles['stripe-form__title']}>{title}</div>

          {showFundraisingCosts &&
            values.donation_type === 'single' &&
            values.amount.single > 0 && (
              // If you are changing the condition ^, make sure it is
              // consistent with isFundraisingCostsVisible() function.
              <>
                <div className={styles['stripe-form__description']}>
                  Do you want to cover the costs of this transaction?
                </div>
                <FundraisingCosts />
              </>
            )}

          <TotalCost values={values} />

          <div className={styles['stripe-form__submit-button']}>{paymentButton}</div>
        </div>
      </div>
    </div>
  );
};

StripeForm.propTypes = {
  title: PropTypes.string.isRequired,
  showFundraisingCosts: PropTypes.bool,
  paymentButton: PropTypes.object.isRequired,
};

export default StripeForm;
